class Controller {

    constructor (serialNumber='', name='', field='', online=false, legacyAccess=false, team=null, latestStatus=null, latestExtendedDataPoint=null, missedHeartbeats=0, currentChemical=null, tankSize=null, cellServiceActive=true, lastKnownLocation=null, archived=false, clockErrors=0, id=null, freeDaysRemaining=0,subscriptionActive=false, subscriptionPlan=null, waterReportingUnits=null, maxGaugeChemRate=null, phone = '', iccid = '', managingDealer = null) {
        this.id = id
        this.serialNumber = serialNumber
        this.phoneNumber = serialNumber
        this.field = field
        this.name = name
        this.online = online
        this.legacyAccess = legacyAccess
        this.team = team
        this.latestStatus = latestStatus
        this.latestExtendedDataPoint = latestExtendedDataPoint
        this.missedHeartbeats = missedHeartbeats
        this.currentChemical = currentChemical
        this.tankSize = tankSize || 0
        this.cellServiceActive = cellServiceActive
        this.lastKnownLocation = lastKnownLocation
        this.archived = archived
        this.clockErrors = clockErrors
        this.subscriptionStatus = 0
        this.waterReportingUnits = waterReportingUnits
        this.maxGaugeChemRate = maxGaugeChemRate || 0

        this.freeDaysRemaining = freeDaysRemaining
        this.subscriptionActive = subscriptionActive
        this.subscriptionPlan = subscriptionPlan
        this.phone = phone
        this.iccid = iccid
        this.managingDealer = managingDealer

        this.getValueForAlarm = this.getValueForAlarm.bind(this)
    }

    static fromAPIObject(obj) {
        return new Controller(obj.serial_number, obj.name, obj.field, obj.online, obj.legacy_access, obj.team, obj.latest_status, obj.latest_extended_data_point, obj.missed_heartbeats, obj.current_chemical, obj.tank_size, obj.cell_service_active, obj.last_known_location, obj.archived, obj.clock_errors, obj.id, obj.free_days_remaining, obj.subscription_active, obj.subscription_plan_id, obj.water_reporting_units, obj.max_gauge_chem_rate, obj.phone, obj.iccid, obj.managing_dealer)
    }

    static fromStorageString(str) {
        let jsonObj = JSON.parse(str)
        return new Controller(jsonObj.serialNumber, jsonObj.name, jsonObj.field, jsonObj.online, jsonObj.legacyAccess, jsonObj.team, jsonObj.latestStatus, jsonObj.latestExtendedDataPoint, jsonObj.missedHeartbeats, jsonObj.currentChemical, jsonObj.tankSize, jsonObj.cellServiceActive, jsonObj.lastKnownLocation, jsonObj.archived, jsonObj.clockErrors, jsonObj.id, jsonObj.waterReportingUnits, jsonObj.maxGaugeChemRate)
    }

    get userIdentifiableName() {
        if (this.name) {
            return `${this.name} ${this.serialNumber}`
        } else if (this.serialNumber) {
            return `Controller ${this.serialNumber}`
        } else {
            return 'Controller'
        }
    }

    get titularName() {
        if (this.name) {
            return `${this.name} ${this.serialNumber}`
        } else if (this.serialNumber) {
            return this.serialNumber
        } else {
            return 'Controller'
        }
    }

    get teamName() {
        if (this.team && this.team.name) {
            return this.team.name
        } else {
            return null
        }
    }

    get connectionStrength() {
        if (this.latestStatus && !this.latestExtendedDataPoint) {
            return this.latestStatus.cell_signal
        } else if (this.latestExtendedDataPoint && !this.latestStatus) {
            return this.latestExtendedDataPoint.cell_signal
        } else if (!this.latestStatus && !this.latestExtendedDataPoint) {
            return 0
        } else if (new Date(this.latestStatus.gmt_datetime) > new Date(this.latestExtendedDataPoint.gmt_datetime)) {
            return this.latestStatus.cell_signal
        } else if (new Date(this.latestExtendedDataPoint.gmt_datetime) > new Date(this.latestStatus.gmt_datetime)) {
            return this.latestExtendedDataPoint.cell_signal
        } else {
            return 0
        }
    }

    get running() {
        if (this.latestStatus) {
            return this.latestStatus.running
        } else {
            return false
        }
    }

    getLatestStatusValue(val) {
        if (this.latestStatus) {
            return this.latestStatus[val]
        } else {
            return null
        }
    }

    getLatestExtendedValue(val) {
        if (this.latestExtendedDataPoint) {
            return this.latestExtendedDataPoint[val]
        } else {
            return null
        }
    }

    get flowRate() {
        if (this.latestStatus) {
            return this.latestStatus.chemical_rate
        } else {
            return null
        }
    }

    get batchSetpoint() {
        if (this.latestExtendedDataPoint) {
            return this.latestExtendedDataPoint.batch_setpoint
        } else {
            return 0
        }
    }

    get waterSetpoint() {
        if (this.latestExtendedDataPoint) {
            return this.latestExtendedDataPoint.water_setpoint
        } else {
            return null
        }
    }

    get batchEnable() {
        if (this.latestExtendedDataPoint) {
            return this.latestExtendedDataPoint.batch_control
        } else {
            return false
        }
    }

    get stopReason() {
        if (this.latestStatus) {
            return STOP_REASON_MESSAGES[this.latestStatus.stop_reason]
        } else {
            return null
        }
    }

    getValueForAlarm(alarm) {
        let currentAlarms = 0

        if (this.latestExtendedDataPoint && !this.latestStatus) {
            currentAlarms = this.latestExtendedDataPoint.current_alarms
            currentAlarms = currentAlarms & this.latestExtendedDataPoint.alarm_raised
        } else if (this.latestExtendedDataPoint && this.latestStatus) {
            if (new Date(this.latestStatus.gmt_datetime) > new Date(this.latestExtendedDataPoint.gmt_datetime)) {
                currentAlarms = this.latestExtendedDataPoint.current_alarms
                currentAlarms = currentAlarms & this.latestStatus.alarm
            } else {
                currentAlarms = this.latestExtendedDataPoint.current_alarms
                currentAlarms = currentAlarms & this.latestExtendedDataPoint.alarm_raised
            }
        }
        let alarmValue = 2 ** alarm
        return ((currentAlarms & alarmValue) === alarmValue)
    }

    get tankTooLowForBatch() {
        let amountLeftToPump = 0
        if(this.batchSetpoint > this.batchTotal){
            amountLeftToPump = this.batchSetpoint - this.batchTotal
        } else {
            amountLeftToPump = this.batchSetpoint
        }
        return !this.legacyAccess && (this.batchEnable && this.tankLevel > 0 && (this.tankLevel < amountLeftToPump))
    }

	get powerLoss() {
		return this.getValueForAlarm(ALARM_CODES.POWER_LOSS)
    }

    get memoryError() {
        return this.getValueForAlarm(ALARM_CODES.MEMORY_ERROR)
    }

    get USBError() {
        return this.getValueForAlarm(ALARM_CODES.USB_ERROR)
    }

    get lowTankLevel() {
        if (this.latestExtendedDataPoint && !isNaN(this.latestExtendedDataPoint.chemical_tank_calculated_alarm_level)) {
            return this.latestExtendedDataPoint.chemical_tank_calculated_alarm_level
        } else {
            return -1
        }
    }

    get tankIsLow() {
        return !this.legacyAccess && ((this.tankLevel <= this.lowTankLevel) && (this.lowTankLevel>0))
    }

    get chemicalOffRateSetpoint() {
        return this.getValueForAlarm(ALARM_CODES.OFF_RATE_SETPOINT)
    }

    get chemicalHighPressure() {
        return this.getValueForAlarm(ALARM_CODES.CHEMICAL_PRESSURE_HIGH)
    }

    get chemicalLowPressure() {
        return this.getValueForAlarm(ALARM_CODES.CHEMICAL_PRESSURE_LOW)
    }

    get chemicalNoFlow() {
        return this.getValueForAlarm(ALARM_CODES.NO_CHEMICAL_FLOW)
    }

    get waterHighPressure() {
        return this.getValueForAlarm(ALARM_CODES.WATER_PRESSURE_HIGH)
    }

    get waterLowPressure() {
        return this.getValueForAlarm(ALARM_CODES.WATER_PRESSURE_LOW)
    }

    get waterNoFlow() {
        return this.getValueForAlarm(ALARM_CODES.NO_WATER_FLOW)
    }

    get clockErrorActive() {
        if (this.latestStatus && !this.latestExtendedDataPoint) {
            return this.latestStatus.clock_error
        } else if (this.latestExtendedDataPoint && !this.latestStatus) {
            return this.latestExtendedDataPoint.clock_error
        } else if (!this.latestStatus && !this.latestExtendedDataPoint) {
            return false
        } else if (new Date(this.latestStatus.gmt_datetime) > new Date(this.latestExtendedDataPoint.gmt_datetime)) {
            return this.latestStatus.clock_error
        } else if (new Date(this.latestExtendedDataPoint.gmt_datetime) > new Date(this.latestStatus.gmt_datetime)) {
            return this.latestExtendedDataPoint.clock_error
        } else {
            return false
        }
    }

    get batteryErrorActive() {
        if(this.latestExtendedDataPoint){
            if(this.latestExtendedDataPoint.battery_voltage_last_power_down<=0 && !this.legacyAccess){
                return true
            }
        }
        return false
    }

    get nonAdjustableFlowRate() {
        if (this.latestStatus) {
            return this.latestStatus.chemical_rate_nonadjustable_setpoint
        } else {
            return null
        }
    }

    get flowUnitsInt() {
        if (this.latestStatus) {
            return this.latestStatus.chemical_units
        } else {
            return null
        }
    }

    get flowUnits() {
        if (this.latestStatus) {
            return FLOW_UNITS[this.latestStatus.chemical_units]
        } else {
            return null
        }
    }

    get batchUnits() {
        if (this.latestStatus) {
            return VOLUME_UNITS[this.latestStatus.batch_units]
        } else {
            return VOLUME_UNITS[2]
        }
    }

    get maxChemRate() {
        if(this.maxGaugeChemRate){
            return this.maxGaugeChemRate
        }
        if (this.latestStatus && this.latestStatus.chemical_units === 0) {
            return 13000
        } else if (this.latestStatus && this.latestStatus.chemical_units === 1) {
            return 10000
        } else if (this.latestStatus && this.latestStatus.chemical_units === 2) {
            return 500
        } else if (this.latestStatus && this.latestStatus.chemical_units === 3) {
            return 100
        } else if (this.latestStatus && this.latestStatus.chemical_units === 4) {
            return 4
        } else {
            return 200
        }
    }

    get maxWaterRate() {
        if (this.latestStatus && this.latestStatus.water_units === 0) {
            return 8000
        } else {
            return 2000
        }
    }

    get chemicalRate() {
        if (this.latestStatus && !isNaN(this.latestStatus.chemical_rate)) {
            return this.latestStatus.chemical_rate
        } else {
            return 0
        }
    }

    get chemicalRateSetpoint() {
        if (this.latestStatus && !isNaN(this.latestStatus.chemical_rate_setpoint)) {
            return this.latestStatus.chemical_rate_setpoint
        } else {
            return 0
        }
    }

    get chemicalRateNonAdjustableSetpoint() {
        if (this.latestStatus && !isNaN(this.latestStatus.chemical_rate_nonadjustable_setpoint)) {
            return this.latestStatus.chemical_rate_nonadjustable_setpoint
        } else {
            return 0
        }
    }

    get waterUnits() {
        if (this.latestStatus) {
            return VOLUME_UNITS[this.latestStatus.water_units]
        } else {
            return VOLUME_UNITS[1]
        }
    }

    get waterReportingUnitText(){
        if (this.latestStatus) {
            return WATER_REPORTING_UNITS[this.latestStatus.water_reporting_units]
        } else {
            return WATER_REPORTING_UNITS[1]
        }
    }

    get tankLevel() {
        if (this.latestStatus) {
            return this.latestStatus.chemical_tank_calculated_level
        } else {
            return null
        }
    }

    get userTotal() {
        if (this.latestStatus) {
            return this.latestStatus.user_total
        } else {
            return null
        }
    }

    get batchTotal() {
        if (this.latestStatus) {
            return this.latestStatus.batch_total
        } else {
            return null
        }
    }

    get waterTotal() {
        if (this.latestStatus) {
            return this.latestStatus.water_total
        } else {
            return null
        }
    }

    get waterTotalReportingUnits() {
        if (this.latestStatus) {
            return this.latestStatus.water_total_reporting_units
        } else {
            return null
        }
    }

    get controlMode() {
        if (this.latestExtendedDataPoint) {
            let auto = (this.latestExtendedDataPoint.automatic_control ? " / Auto" : "/ Man")
            return `${CONTROL_MODES[this.latestExtendedDataPoint.control_mode]}${auto}`
        } else {
            return null
        }
    }
	
	get autoManMode() {
        if (this.latestExtendedDataPoint) {
            return this.latestExtendedDataPoint.automatic_control
        } else {
            return null
        }
    }

    get remoteSignalMode() {
        if (this.latestExtendedDataPoint) {
            return `${REMOTE_SIGNAL_MODES[this.latestExtendedDataPoint.remote_signal_control]}`
        } else {
            return null
        }
    }
	
	get rateAdjustMode() {
        if (this.latestStatus) {
            return this.latestStatus.rate_adjust_mode
        } else {
            return null
        }
    }

    get scheduledStartMode() {
        if (this.latestExtendedDataPoint) {
            return START_STOP_MODES[this.latestExtendedDataPoint.scheduled_start_mode]
        } else {
            return "Disabled"
        }
    }

    get scheduledStopMode() {
        if (this.latestExtendedDataPoint) {
            return START_STOP_MODES[this.latestExtendedDataPoint.scheduled_stop_mode]
        } else {
            return "Disabled"
        }
    }

    get scheduledStartTime() {
        let formattedControllerStartTime = "00:00"
        let ext = this.latestExtendedDataPoint
        if (ext && ext.scheduled_start_time) {
            let startTime = ext.scheduled_start_time
            let hours = startTime.slice(0,2)
            let minutes = startTime.slice(3,5)
            formattedControllerStartTime = `${hours}:${minutes}`
        }
        return formattedControllerStartTime
    }

    get scheduledStopTime() {
        let formattedControllerStopTime = "00:00"
        let ext = this.latestExtendedDataPoint
        if (ext && ext.scheduled_stop_time) {
            let stopTime = ext.scheduled_stop_time
            let hours = stopTime.slice(0,2)
            let minutes = stopTime.slice(3,5)
            formattedControllerStopTime = `${hours}:${minutes}`
        }
        return formattedControllerStopTime
    }

    get waterTotalizerMode() {
        if (this.latestExtendedDataPoint) {
            return WATER_TOTALIZER_MODES[this.latestExtendedDataPoint.water_totalizer_mode]
        } else {
            return "Disabled"
        }
    }

    get modemModel() {
        if (this.latestExtendedDataPoint) {
            return MODEM_MODELS[this.latestExtendedDataPoint.modem_model]
        } else {
            return "Unknown"
        }
    }
	
	get cellTech() {
        if (this.latestStatus) {
            return MODEM_CELL_TECH[this.latestStatus.cell_access_technology]
        } else {
            return "Unknown"
        }
    }

    get modemLogLevel() {
        if (this.latestExtendedDataPoint) {
            return MODEM_LOG_LEVELS[this.latestExtendedDataPoint.modem_error_log_level]
        } else {
            return "None"
        }
    }

    get lastUpdatedGMT() {
        let safelyParseUTCDate = (s) => {
            try {
                const str = s.replace("Z", "")
                const dateTime = str.split('T')
                const dateBits = dateTime[0].split('-')
                const timeBits = dateTime[1].split(':')
                return new Date(Date.UTC(dateBits[0], parseInt(dateBits[1]) - 1, dateBits[2], timeBits[0], timeBits[1], timeBits[2]))
            } catch (e) {
                return null
            }
        }

        if (this.latestStatus && !this.latestExtendedDataPoint) {
            return safelyParseUTCDate(this.latestStatus.gmt_datetime)
        } else if (this.latestExtendedDataPoint && !this.latestStatus) {
            return safelyParseUTCDate(this.latestExtendedDataPoint.gmt_datetime)
        } else if (!this.latestStatus && !this.latestExtendedDataPoint) {
            return null
        } else if (new Date(this.latestStatus.gmt_datetime) > new Date(this.latestExtendedDataPoint.gmt_datetime)) {
            return safelyParseUTCDate(this.latestStatus.gmt_datetime)
        } else if (new Date(this.latestExtendedDataPoint.gmt_datetime) > new Date(this.latestStatus.gmt_datetime)) {
            return safelyParseUTCDate(this.latestExtendedDataPoint.gmt_datetime)
        } else {
            return null
        }
    }

    get lastUpdatedExtendedGMT() {
        let safelyParseUTCDate = (s) => {
            try {
                const str = s.replace("Z", "")
                const dateTime = str.split('T')
                const dateBits = dateTime[0].split('-')
                const timeBits = dateTime[1].split(':')
                return new Date(Date.UTC(dateBits[0], parseInt(dateBits[1]) - 1, dateBits[2], timeBits[0], timeBits[1], timeBits[2]))
            } catch (e) {
                return null
            }
        }

        if (!this.latestExtendedDataPoint) {
            return null
        } else {
            return safelyParseUTCDate(this.latestExtendedDataPoint.gmt_datetime)
        }
    }

    get lastUpdatedLocal() {
        let safelyParseDate = (s) => {
            try {
                let str = s.replace("Z", "")
                let dateTime = str.split('T')
                let dateBits = dateTime[0].split('-')
                let timeBits = dateTime[1].split(':')
                return new Date(dateBits[0], parseInt(dateBits[1]) - 1, dateBits[2], timeBits[0], timeBits[1], timeBits[2])
            } catch (e) {
                return null
            }
        }

        if (this.latestStatus && this.latestStatus.local_datetime && !this.latestExtendedDataPoint) {
            return safelyParseDate(this.latestStatus.local_datetime)
        } else if (this.latestExtendedDataPoint && this.latestExtendedDataPoint.local_datetime && !this.latestStatus) {
            return safelyParseDate(this.latestExtendedDataPoint.local_datetime)
        } else if (!this.latestStatus && !this.latestExtendedDataPoint) {
            return null
        }

        if (this.latestExtendedDataPoint && this.latestStatus) {
            if (new Date(this.latestStatus.gmt_datetime) > new Date(this.latestExtendedDataPoint.gmt_datetime)) {
                return safelyParseDate(this.latestStatus.local_datetime)
            } else if (new Date(this.latestExtendedDataPoint.gmt_datetime) > new Date(this.latestStatus.gmt_datetime)) {
                return safelyParseDate(this.latestExtendedDataPoint.local_datetime)
            }
        } else {
            return null
        }
    }

    get lastUpdatedTimeString() {
        if (this.lastUpdatedGMT) {
            let lu = this.lastUpdatedGMT
            let hours = (lu.getHours() % 12)
            hours = (hours === 0 ? 12 : hours)
            let suffix = (lu.getHours() < 12 ? "AM" : "PM")
            let minutes = lu.getMinutes()
            minutes = (minutes < 10 ? `0${minutes}`: minutes)
            return `${hours}:${minutes} ${suffix}`
        } else {
            return null
        }
    }

    get lastUpdatedDateString() {
        if (this.lastUpdatedGMT) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"]
            let lu = this.lastUpdatedGMT
            let month = monthNames[lu.getMonth()]
            let day = lu.getDate()
            let year = lu.getFullYear()
            return `${month} ${day}, ${year}`
        } else {
            return null
        }
    }

    get lastUpdatedExtendedTimeString() {
        if (this.lastUpdatedExtendedGMT) {
            let lu = this.lastUpdatedExtendedGMT
            let hours = (lu.getHours() % 12)
            hours = (hours === 0 ? 12 : hours)
            let suffix = (lu.getHours() < 12 ? "AM" : "PM")
            let minutes = lu.getMinutes()
            minutes = (minutes < 10 ? `0${minutes}`: minutes)
            return `${hours}:${minutes} ${suffix}`
        } else {
            return null
        }
    }

    get lastUpdatedExtendedDateString() {
        if (this.lastUpdatedExtendedGMT) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"]
            let lu = this.lastUpdatedExtendedGMT
            let month = monthNames[lu.getMonth()]
            let day = lu.getDate()
            let year = lu.getFullYear()
            return `${month} ${day}, ${year}`
        } else {
            return null
        }
    }

    get localDateTime() {
        return this.lastUpdatedLocal
    }

    get localTimeString() {
        if (this.localDateTime) {
            let lo = this.localDateTime
            let hours = (lo.getHours() % 12)
            hours = (hours === 0 ? 12 : hours)
            let suffix = (lo.getHours() < 12 ? "AM" : "PM")
            let minutes = lo.getMinutes()
            minutes = (minutes < 10 ? `0${minutes}`: minutes)
            return `${hours}:${minutes} ${suffix}`
        } else {
            return null
        }
    }

    get localDateString() {
        if (this.lastUpdatedGMT) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"]
            let lo = this.localDateTime
            let month = monthNames[lo.getMonth()]
            let day = lo.getDate()
            let year = lo.getFullYear()
            return `${month} ${day}, ${year}`
        } else {
            return null
        }
    }

}

export const WATER_UNITS = {
    0: 'LITERS',
    1: 'GALLONS'
}

export const FLOW_UNITS = {
    0: 'ML/M',
    1: 'OZ/AC',
    2: 'GPA',
    3: 'GPM',
    4: 'OZ/M',
    5: 'GPH',
    6: 'LPM'
}

const VOLUME_UNITS = {
    0: 'L',
    1: 'GAL',
    2: 'GAL',
    3: 'GAL',
    4: 'GAL',
    5: 'GAL',
    6: 'L'
}

const WATER_REPORTING_UNITS = {
    0: 'L',
    1: 'GAL',
    2: 'AC-FT'
}

const CONTROL_MODES = {
    0: 'PWM',
    1: '4-20',
    2: 'Valve',
}

const START_STOP_MODES = {
    0: 'Disabled',
    1: 'Once',
    2: 'Repeat',
}

const WATER_TOTALIZER_MODES = {
    0: 'Disabled',
    1: 'While Running',
    2: 'Always',
}

const MODEM_MODELS = {
    0: 'Unknown',
    1: 'Verizon LTE',
    2: 'AT&T (or Rogers) LTE/3G', 
    3: 'Verizon CDMA',
    4: 'Telstra/EUG/L4E1',
    5: 'Cat M1',
    6: 'Cat 4',
}

const MODEM_CELL_TECH = {
    0: 'GSM',
    1: 'GSM Compact', 
    2: 'UTRAN (3G)',
    3: 'GSM with EGPRS',
    4: 'UTRAN with HSDPA (3G+)',
    5: 'UTRAN with HSUPA (3G+)',
    6: 'UTRAN with HSDPA and HSUPA (3G+)',
    7: 'E-UTRAN (4G LTE)',
}

const MODEM_LOG_LEVELS = {
    0: 'Disabled',
    1: 'Log Level 1',
    2: 'Log Level 2',
    3: 'RX Diag',
    4: 'TX Diag',
    5: 'TX/RX Diag',
    255: 'None',
}

const RATE_ADJUST_MODES = {
	0: 'None',
    1: 'Water Prop',
    2: 'Remote Cmd',
    3: 'Water & Remote',
}

const REMOTE_SIGNAL_MODES = {
	0: 'Disabled',
    1: '0-10V',
    2: '4-20mA',
}

const STOP_REASON_MESSAGES = {
    0 : "",
    1 : "",
    2 : "",
    4 : "Water Pressure Too High",
    5 : "Water Pressure Too Low",
    6 : "Chemical Pressure Too High",
    7 : "Chemical Pressure Too Low",
    8 : "Error with USB",
    9 : "No Chemical Flow",
    10 : "Off Rate Setpoint",
    11 : "No Water Flow",
    12 : "Power Loss",
    13 : "Aux Digital Input",
    14 : "Batch Done, Irrigation Kill",
    15 : "Memory Error",
    32 : "Stopped Remotely",
    33 : "Stopped from Controller",
    34 : "Batch Complete",
    35 : "Prop Setpoint Off",
    36 : "Scheduled Stop"
}

const ALARM_CODES = {
    NO_ALARM : -1,
    STOP_1 : 0,
    STOP_2 : 1,
    WATER_PRESSURE_HIGH : 3,
    WATER_PRESSURE_LOW : 4,
    CHEMICAL_PRESSURE_HIGH : 5,
    CHEMICAL_PRESSURE_LOW : 6,
    USB_ERROR : 7,
    NO_CHEMICAL_FLOW : 8,
    OFF_RATE_SETPOINT : 9,
    NO_WATER_FLOW : 10,
    POWER_LOSS : 11,
    AUX_DIGITAL_INPUT_STOP : 12,
    BATCH_DONE_IRRIGATION_KILL : 13,
    MEMORY_ERROR : 14,
    REMOTE_STOP : 31,
    CONTROLLER_STOP : 32,
    BATCH_COMPLETE : 33,
    PROP_SETPOINT_OFF : 34,
    SCHEDULED_STOP : 35
}

export default Controller



// WEBPACK FOOTER //
// ./src/models/Controller.js